if (!customElements.get('zinko-card-gallery')) {
  customElements.define('zinko-card-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const track = this.querySelector('.zinko-card-gallery__track');
      let startX = 0;
      let startY = 0;
      let moved = false;
      let lastScroll = 0;
      track.addEventListener('touchstart', event => {
        this.cancelHint();
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        moved = false;
      }, { passive: true, signal });
      track.addEventListener('touchmove', event => {
        if (Math.abs(event.touches[0].clientX - startX) > 8 || Math.abs(event.touches[0].clientY - startY) > 8) moved = true;
      }, { passive: true, signal });
      track.addEventListener('scroll', () => {
        lastScroll = Date.now();
      }, { passive: true, signal });
      track.addEventListener('click', event => {
        if (moved || Date.now() - lastScroll < 200) {
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        }
      }, { capture: true, signal });
      const grid = this.closest('#product-grid');
      const item = this.closest('li');
      if (grid && grid.children[1] === item && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.hintObserver = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.6) || grid.dataset.zinkoSwipeHint || getComputedStyle(this).display === 'none') return;
          grid.dataset.zinkoSwipeHint = 'shown';
          this.hintObserver.disconnect();
          this.hintTimer = setTimeout(() => {
            if (moved || track.scrollLeft > 1) return;
            track.classList.add('zinko-card-gallery__track--hint');
            track.scrollTo({left:Math.min(track.clientWidth * 0.25, 65), behavior:'smooth'});
            this.hintReturnTimer = setTimeout(() => {
              track.scrollTo({left:0, behavior:'smooth'});
              this.hintEndTimer = setTimeout(() => track.classList.remove('zinko-card-gallery__track--hint'), 500);
            }, 700);
          }, 600);
        }, {threshold:0.6});
        this.hintObserver.observe(this);
      }
    }
    cancelHint() {
      clearTimeout(this.hintTimer);
      clearTimeout(this.hintReturnTimer);
      clearTimeout(this.hintEndTimer);
      this.hintObserver?.disconnect();
      this.querySelector('.zinko-card-gallery__track')?.classList.remove('zinko-card-gallery__track--hint');
    }
    disconnectedCallback() {
      this.cancelHint();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
